<template>
  <div>
    <Navbar />
    <section>
      <div class="container">
        <NdcTitle :ndc="ndc" />
        <Search />
        <Breadcrumb :ndc="ndc" />
        <Note :ndc="ndc" />
        <Reference :ndc="ndc" />
        <NdcTile :ndc="ndc" />
      </div>
    </section>
  </div>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify';
import Navbar from './Navbar';
import NdcTitle from './NdcTitle';
import Search from './Search';
import Breadcrumb from './Breadcrumb';
import Note from './Note';
import Reference from './Reference';
import NdcTile from './NdcTile';
import { getNdc } from '../graphql/queries';
import { notation } from '../utils';

const NUM_PER_ROW = 3;
const JSON_ATTRS = [
  'narrower',
  'broader',
  'note',
  'seeAlso',
  'related',
];

export default {
  name: 'Ndc',
  data() {
    return {
      ndcId: null,
      ndc: {},
    };
  },
  components: {
    Navbar,
    NdcTitle,
    Search,
    Breadcrumb,
    Note,
    Reference,
    NdcTile,
  },
  async mounted() {
    const paramId = `${this.$route.params.id}${this.$route.hash}`;
    this.ndcId = paramId;
    this.updateNdc();
  },
  beforeRouteUpdate(to, from, next) {
    const paramId = `${to.params.id}${to.hash}`;
    if (paramId) {
      if (this.ndcId !== paramId) {
        this.ndcId = paramId;
        this.updateNdc();
      }
    }
    next();
  },
  methods: {
    async updateNdc() {
      if (this.ndcId) {
        let ndc = await API.graphql(graphqlOperation(getNdc, { id: this.ndcId }));
        ndc = ndc.data.getNdc;
        this.ndc = this.parse_json(ndc);

        if (this.ndc.narrower) {
          this.ndc.narrower.sort((x, y) => (x.id > y.id ? 1 : -1));
          this.ndc.narrowers = this.groups(this.ndc.narrower, NUM_PER_ROW);
        }
      }
    },
    parse_json(ndc) {
      const newNdc = Object.assign({}, ndc);
      JSON_ATTRS.forEach((attr) => {
        if (ndc[attr]) {
          newNdc[attr] = JSON.parse(ndc[attr]);
        }
      });
      return newNdc;
    },
    groups(arr, every) {
      const result = [];
      let group = [];
      arr.forEach((a, index) => {
        group.push(a);
        if ((index + 1) % every === 0) {
          result.push(group);
          group = [];
        }
      });
      if (group.length > 0) {
        result.push(group);
      }
      return result;
    },
    notation,
  },
};
</script>

<style scoped>
section {
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Ndc.vue